// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoaderBase_loader__ZtZBe","contentWrapper":"LoaderBase_contentWrapper__1YB9n"};